import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GetBannersResponse } from '../../../../typings/api';

//  Fetch the banners from the API
function getBanners() {
  return get<GetBannersResponse>('/api/banners');
}

export const bannersQueryKey: QueryKey = ['banners'];

/**
 * Hook for fetching banners.
 */
export default function useBanners() {
  return useQuery<GetBannersResponse>({
    queryFn: getBanners,
    queryKey: bannersQueryKey,
  });
}
